import './lib/slick.min';
import './lib/jquery.fancybox.min';
import './lib/jquery.maskedinput';
import './lib/ajax';

$(function() {
    const pageWrapper = $('.page-wrapper'),
        $document = $(document);

    function SplitLetters(selector, wrapper = "$", delimeter = " ", joiner = " ") {
        //let nodeList = document.querySelectorAll(selector);
        let nodeList = selector;
        let ind = 0;

        function parseLetters(node) {
            let htmlNode = node.cloneNode();
            htmlNode.innerHTML = "";

            for (let i = 0; i < node.childNodes.length; i++) {
                let childNode = node.childNodes[i];
                if (childNode.nodeType === Node.TEXT_NODE) {
                    htmlNode.innerHTML += childNode.data
                        .split(delimeter)
                        .map(function(letter) {
                            if (letter === " ") {
                                return letter;
                            }
                            else {
                                ind++;
                                return wrapper.replace(/\$/g, letter).replace(/#/g, ind);
                            }
                        })
                        .join(joiner);
                }
                else {
                    htmlNode.appendChild(parseLetters(childNode));
                }
            }

            return htmlNode;
        }

        nodeList.innerHTML = parseLetters(nodeList).innerHTML;
    }

    //SplitLetters('.heading', "<span class=\"word word-#\">$</span>", " ", " ");

    $('.heading').each(function() {
        SplitLetters(this, "<span class=\"word word-#\">$</span>", " ", " ");
    });

    pageWrapper.addClass('page-loaded');

    if ('IntersectionObserver' in window &&
        'IntersectionObserverEntry' in window &&
        'intersectionRatio' in window.IntersectionObserverEntry.prototype) {

        pageWrapper.addClass('isIntersection');

        const options = {
            rootMargin: '0px',
            threshold: [0, 0.1, 0.2, 0.3, 0.4, 0.5, 0.6, 0.7, 0.8, 0.9, 1]
        };

        const observer = new IntersectionObserver(items=> {
            items.forEach(item => {
                if(item.isIntersecting && item.intersectionRatio>0.1) {
                    item.target.classList.add('visible');
                }
            });
        }, options);

        $('.scrolr').each((i, el) => {
            observer.observe(el);
        });
    }

    function outerClick(selector, fn) {
        $document.on('click', function(e) {
            if ($(e.target).closest(selector).length) return;
            fn();
        });
    }

    function slickWrapper(selector, options) {
        const block = $(selector);

        block.each(function() {
            const $this = $(this),
                slider = $this.find('.slider'),
                arrowPrev = $this.find('.slider-arrow--prev'),
                arrowNext = $this.find('.slider-arrow--next'),
                dotsContainer = $this.find('.slider-dots');

            const opts = $.extend({}, {
                prevArrow: arrowPrev,
                nextArrow: arrowNext,
                appendDots: dotsContainer
            }, options);

            return slider.slick(opts);
        });
    }

    function getCSS(element, property) {
        return window.getComputedStyle(element, null).getPropertyValue(property);
    }

    // fancybox
    $('[data-fancybox]').fancybox({
        hash: false,
        closeClickOutside: true,
        buttons: [
            'close'
        ]
    });

    // jQuery Masked Input Plugin
    $('[data-input-phone]').mask('+7 (999) 999 99 99');

    // tabs
    $document.on('click', '[data-tab]', function(e) {
        e.preventDefault();
        const $this = $(this),
            tabsName = $this.data('tab'),
            id = $this.data('tab-id');

        $('[data-tab-block='+ tabsName +']').removeClass('active');
        $('[data-tab-block-id=' + id +']').addClass('active');
    });

    // filter
    const filterState = {
        type: 'ip', // 'ooo'
        count: 'none', // 'less5'
        zero: false,
        setState: function(obj) {
            for (let key in obj) {
                if (this.hasOwnProperty(key)) {
                    this[key] = obj[key];
                }
            }
            $document.trigger('changeFilter', this);
        }
    };

    $document.on('changeFilter', function(e, obj) {
        const tariffElements = $('[data-tariff]');

        tariffElements.each(function() {
            const $this = $(this),
                data = $this.data('tariff');
            
            if (!$this.hasClass('active') &&
                data.type === obj.type &&
                data.zero === obj.zero) {
                if (obj.zero === true || data.count === obj.count) {
                    tariffElements.removeClass('active');
                    $this.addClass('active');

                    const slider = $this.find('.slider');

                    if (slider.length && slider.slick) {
                        slider.slick('setPosition');
                    }

                    return true;
                }
            }
        });
    });

    // toggle
    $document.on('click', '.toggle__block', function(e) {
        const $this = $(this),
            dataType = $this.data('type'),
            isActive = $this.hasClass('active');

        if (!isActive) {
            const parent = $this.closest('.toggle'),
                active = $this.siblings('.toggle__active'),
                index = $this.index();

            parent.find('.toggle__block').removeClass('active');
            $this.addClass('active');
            active.css('transform', 'translateX('+ 100*index +'%)');

            if (dataType) {
                filterState.setState({
                    type: dataType
                });
            }
        }
    });

    // select
    $document.on('click', '[data-select-head]', function() {
        $(this).closest('[data-select]').toggleClass('active');
    });

    outerClick('[data-select]', function() {
        $('[data-select]').removeClass('active');
    });

    $document.on('click', '[data-select-item]', function() {
        const $this = $(this),
            dataFilterCount = $this.data('select-item'),
            text = $this.text(),
            value = $this.data('select-item'),
            parent = $this.closest('[data-select]'),
            title = parent.find('[data-select-title]'),
            input = parent.find('[data-select-input]');

        parent.find('[data-select-item]').removeClass('active');
        $this.addClass('active');

        input.val(value);
        title.text(text);
        parent.removeClass('active');

        if (dataFilterCount) {
            filterState.setState({
                count: dataFilterCount
            });
        }
    });

    // filter zero toggle
    $document.on('change', '#filter-zero', function() {
        const isChecked = $(this).prop('checked');

        filterState.setState({
            zero: isChecked
        });
    });

    // tariffs-list slider
    const tariffsSlider = slickWrapper('.tariffs-list', {
        slidesToShow: 3,
        dots: true,
        responsive: [
            {
                breakpoint: 1210,
                settings: {
                    slidesToShow: 2
                }
            },
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: 1
                }
            }
        ]
    });

    const Modal = function() {
        this.modalSelector = '[data-modal]';
        this.body = $('body');
        this.fixedElements = $('.header').add(this.body);
        this.wrapper = $('.wrapper');
        this.scrollbarWidth = parseInt(window.innerWidth) - parseInt(document.documentElement.clientWidth);
        this.timeoutClose = 400;
    };
    Modal.prototype.otherOpen = function(id) {
        return $(this.modalSelector).filter('.active');
    };
    Modal.prototype.open = function(id, mouse) {
        const $modal = $(`[data-modal=${id}]`),
            inner = $modal.find('.modal__inner'),
            otherOpen = this.otherOpen(),
            transition = getCSS(inner[0], 'transition');

        if (mouse && mouse.x && mouse.y) {
            inner.css('transition', 'none');

            inner.css({
                top: mouse.y + 'px',
                left: mouse.x + 'px'
            });
        }

        setTimeout(function() {
            inner.css('transition', transition);
            $modal.addClass('active').focus();
        }, 200);

        if (!otherOpen.length) {
            this.fixedElements.css({
                'padding-right': this.scrollbarWidth
            });
            this.body.addClass('modal-open');
        } else {
            otherOpen.removeClass('active');
        }
    };
    Modal.prototype.close = function(id) {
        const that = this;

        const $modal = $(`[data-modal=${id}]`),
            inner = $('.modal__inner');

        // inner.css({
        //     top: '',
        //     left: ''
        // });

        if (id) {
            $modal.removeClass('active');
        } else {
            $('[data-modal]').removeClass('active');
        }

        if (!this.otherOpen().length) {
            setTimeout(function() {
                that.fixedElements.css({
                    'padding-right': ''
                });
                that.body.removeClass('modal-open');
            }, this.timeoutClose);
        }
    };

    const modal = new Modal();
    window.modal = modal;

    // modals
    $document.on('click', '[data-modal-open]', function(e) {
        e.preventDefault();
        const $this = $(this),
            modalId = $this.data('modal-open');
        
        modal.open(modalId, {
            x: e.clientX,
            y: e.clientY
        });
    });

    $document.on('click', '[data-modal-close]', function(e) {
        e.preventDefault();
        const $this = $(this),
            modalId = $this.data('modal-close');
        modal.close(modalId);
    });

    $document.on('click', '[data-modal]', function(e) {
        if ($(e.target).closest('[data-modal-inner], ymaps').length) return;
        e.preventDefault();
        const modalId = $(e.currentTarget).data('modal-open');
        modal.close(modalId);
    });

    // input
    $document.on('focus', '.input-block__input', function() {
        const $this = $(this),
            parent = $this.closest('.input-block');

        if (parent.hasClass('error')) {
            $this.val('');
            parent.removeClass('error');
        }
    });

    // maps
    function initMap(id) {
        if ($(id).length) {
            function init(){
                const mapElement = document.getElementById('map'),
                    lat = parseFloat(mapElement.dataset.lat),
                    lon = parseFloat(mapElement.dataset.lon),
                    caption = mapElement.dataset.caption,
                    myMap = new ymaps.Map("map", {
                        center: [lat,lon],
                        zoom: 17,
                        controls: []
                    });

                myMap.geoObjects.add(new ymaps.Placemark([lat,lon], {
                    iconCaption: caption
                }, {preset:'islands#redDotIcon'}));
            }
            ymaps.ready(init);
        }
    }

    setTimeout(function() {
        initMap('#map');
    }, 4000);

    // отправка формы
 /*   $document.on('submit', 'form', function(e) {
        e.preventDefault();

        const $this = $(this),
            modalEl = $this.closest('[data-modal]');

        if (modalEl.length) {
            const modalId = modalEl.data('modal');
            modal.close(modalId);
        }

        modal.open('thanks');
    });*/

    // скролл до элемента по id
    $document.on('click', '[data-scroll-to]', function(e) {
        e.preventDefault();
        const id = $(this).data('scroll-to'),
            header = $('.header'),
            el = $('#'+ id);

        let offset = 20;

        if (header.length) {
            offset += header.height();
        }

        if (!el.length) return;

        $('html, body').animate({
            scrollTop: el.offset().top - offset
        }, 600);
    });

    // подсказки аббревиатур
    $document.on('mouseenter', '[data-tip]', function(e) {
        const $this = $(this),
            width = $this.width(),
            height = $this.height(),
            offset = $this.offset(),
            id = $this.data('tip'),
            block = $('[data-tip-block='+ id +']');

        if (block.length) {
            block.css({
                top: offset.top + height,
                left: offset.left + width/2
            }).addClass('active');
        }
    });

    $document.on('mouseleave', '[data-tip]', function(e) {
        $('[data-tip-block]').removeClass('active');
    });
});